import React, { Component } from "react";

class SimpleTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
    this.wrapperRef = React.createRef();
    this.hideTimeout = null;
  }

  componentDidMount() {
    // Expose close function globally for navigation clicks
    window.closeTooltip = () => {
      this.setState({ isVisible: false });
    };
  }

  componentWillUnmount() {
    // Clean up timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    // Clean up global function
    if (window.closeTooltip) {
      delete window.closeTooltip;
    }
  }

  handleMouseEnter = () => {
    if (this.props.show) {
      // Clear any pending hide timeout
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.setState({ isVisible: true });
    }
  };


  handleMouseLeave = () => {
    // Add a small delay before hiding to allow cursor to reach tooltip
    this.hideTimeout = setTimeout(() => {
      this.setState({ isVisible: false });
      this.hideTimeout = null;
    }, 100);
  };

  handleTooltipMouseEnter = () => {
    // Keep tooltip visible when hovering over it
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    this.setState({ isVisible: true });
  };

  handleTooltipMouseLeave = () => {
    this.setState({ isVisible: false });
  };

  render() {
    const { children, content, show = false } = this.props;
    const { isVisible } = this.state;

    if (!show) {
      return children;
    }

    return (
      <div
        ref={this.wrapperRef}
        className="tooltip-wrapper"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {children}
        {isVisible && content && (
          <div 
            className="tooltip-content"
            onMouseEnter={this.handleTooltipMouseEnter}
            onMouseLeave={this.handleTooltipMouseLeave}
          >
            {content}
          </div>
        )}
      </div>
    );
  }
}

export default SimpleTooltip;

